import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
	standalone: true,
	name: 'bitrate',
})
export class BitratePipe implements PipeTransform {
	/**
	 * Converts a bitrate value (in bits per second) to a human-readable format
	 * @param value - Bitrate in bits per second (bps)
	 * @returns Formatted string with appropriate unit (bps, Kbps, Mbps, Gbps)
	 */
	transform(value?: number | null): string {
		if (!value || value === 0) return '--';

		const units = ['bps', 'Kbps', 'Mbps', 'Gbps'];
		let unitIndex = 0;
		let bitrate = value;

		// Convert to the most appropriate unit
		while (bitrate >= 1000 && unitIndex < units.length - 1) {
			bitrate /= 1000;
			unitIndex++;
		}

		// Format with 2 decimal places
		const formattedValue = bitrate.toFixed(2);

		return `${formattedValue} ${units[unitIndex]}`;
	}
}
